import { sitesApi } from '../services/sitesApi';
import {
  indexCameraPlacementLookups,
  type SafetyLocationLookups,
} from './locationDisplay';

/** Fetch site display name + camera placements for customer place labels. */
export async function loadSiteLocationLookups(
  siteId: string,
): Promise<SafetyLocationLookups> {
  const scoped = String(siteId || '').trim();
  if (!scoped) return {};
  try {
    const res = await sitesApi.listCameraPlacements(scoped);
    return {
      siteId: scoped,
      siteDisplayName: res.site_display_name || scoped,
      cameraPlacementById: indexCameraPlacementLookups(res.placements || []),
    };
  } catch {
    return { siteId: scoped, siteDisplayName: scoped, cameraPlacementById: {} };
  }
}
